import {checkError, closeAlert, receiveErrorAlert, receiveSuccessAlert} from "./commonsActions";
import {
    addPromoVideoFolder,
    addPromoVideoUrl,
    deletePromoVideoFolder,
    deletePromoVideoUrl, getPromoVideoAmountInCompanies,
    getPromoVideoFolders,
    updatePromoVideoFolder,
    updatePromoVideoUrl
} from "../helpers/promoVideoService";

export const FETCH_PROMO_VIDEO_FOLDERS_BEGIN = 'FETCH_PROMO_VIDEO_FOLDERS_BEGIN';
export const FETCH_PROMO_VIDEO_FOLDERS_SUCCESS = 'FETCH_PROMO_VIDEO_FOLDERS_SUCCESS';

export const FETCH_PROMO_VIDEO_AMOUNT_IN_COMPANIES_BEGIN = 'FETCH_PROMO_VIDEO_AMOUNT_IN_COMPANIES_BEGIN';
export const FETCH_PROMO_VIDEO_AMOUNT_IN_COMPANIES_SUCCESS = 'FETCH_PROMO_VIDEO_AMOUNT_IN_COMPANIES_SUCCESS';

/*
 * action creators
 */

export const fetchPromoVideoFolders = query => dispatch => {
    dispatch({type: FETCH_PROMO_VIDEO_FOLDERS_BEGIN});
    return getPromoVideoFolders(query).then(res => {
        dispatch({
            type: FETCH_PROMO_VIDEO_FOLDERS_SUCCESS,
            promoVideoFolders: res.data,
        });
        return res;
    }, error => {
        dispatch(checkError(error));
        dispatch(receiveErrorAlert(error));
        setTimeout(() => {
            dispatch(closeAlert());
        }, 2000);
    })
};

export const savePromoVideoFolder = folder => dispatch => {
    return addPromoVideoFolder(folder).then(res => {
        dispatch(receiveSuccessAlert('Success'));
        setTimeout(() => {
            dispatch(closeAlert());
        }, 2000);
        return res;
    }, error => {
        dispatch(checkError(error));
        throw error;
    })
};

export const updateSinglePromoVideoFolder = folder => dispatch => {
    return updatePromoVideoFolder(folder).then(res => {
        dispatch(receiveSuccessAlert('Update Successful'));
        setTimeout(() => {
            dispatch(closeAlert());
        }, 2000);
        return res;
    }, error => {
        dispatch(checkError(error));
        throw error;
    })
};

export const removePromoVideoFolder = folderId => dispatch => {
    return deletePromoVideoFolder(folderId).then(res => {
        return res;
    }, error => {
        dispatch(checkError(error));
        dispatch(receiveErrorAlert(error));
        setTimeout(() => {
            dispatch(closeAlert());
        }, 2000);
    })
};

export const savePromoVideoUrl = url => dispatch => {
    return addPromoVideoUrl(url).then(res => {
        dispatch(receiveSuccessAlert('Success'));
        setTimeout(() => {
            dispatch(closeAlert());
        }, 2000);
        return res;
    }, error => {
        dispatch(checkError(error));
        throw error;
    })
};

export const updateSinglePromoVideoUrl = url => dispatch => {
    return updatePromoVideoUrl(url).then(res => {
        dispatch(receiveSuccessAlert('Update Successful'));
        setTimeout(() => {
            dispatch(closeAlert());
        }, 2000);
        return res;
    }, error => {
        dispatch(checkError(error));
        throw error;
    })
};

export const removePromoVideoUrl = urlId => dispatch => {
    return deletePromoVideoUrl(urlId).then(res => {
        return res;
    }, error => {
        dispatch(checkError(error));
        dispatch(receiveErrorAlert(error));
        setTimeout(() => {
            dispatch(closeAlert());
        }, 2000);
    })
};

export const fetchPromoVideoAmountInCompanies = companyNameFilter => dispatch => {
    dispatch({type: FETCH_PROMO_VIDEO_AMOUNT_IN_COMPANIES_BEGIN});
    return getPromoVideoAmountInCompanies(companyNameFilter).then(res => {
        dispatch({
            type: FETCH_PROMO_VIDEO_AMOUNT_IN_COMPANIES_SUCCESS,
            promoVideoAmountInCompanies: res.data,
        });
        return res;
    }, error => {
        dispatch(checkError(error));
        dispatch(receiveErrorAlert(error));
        setTimeout(() => {
            dispatch(closeAlert());
        }, 2000);
    })
};


// WEBPACK FOOTER //
// ./src/actions/promoVideoActions.js